import api from "./api";

const paymentService = {};

const endpoint = "/payments";

paymentService.get = function () {
  return api.get(`${endpoint}/services`).then((res) => res.data);
};

paymentService.post = function (service) {
  return api.post(`${endpoint}`, service).then((res) => res.data);
};

export default paymentService;
